/**
 * Division 관련 유틸리티 함수들
 */

// Division ID를 한글 라벨로 변환하는 함수
export const getDivisionLabel = (divisionId) => {
  const divisionMap = {
    'SUPPLIER': '시공업체',
    'RAW_MATERIAL': '원판',
    'PROCESS': '가공',
    'SUB_MATERIAL_PROCESS': '가공부자재',
    'SUB_MATERIAL_BUILD': '시공부자재'
  };
  return divisionMap[divisionId] || divisionId;
};

// Division 라벨을 ID로 변환하는 함수
export const getDivisionId = (divisionLabel) => {
  const reverseDivisionMap = {
    '시공업체': 'SUPPLIER',
    '원판': 'RAW_MATERIAL',
    '가공': 'PROCESS',
    '가공부자재': 'SUB_MATERIAL_PROCESS',
    '시공부자재': 'SUB_MATERIAL_BUILD'
  };
  return reverseDivisionMap[divisionLabel] || divisionLabel;
};

// 모든 Division 옵션을 반환하는 함수
export const getDivisionOptions = () => {
  return [
    { id: 'RAW_MATERIAL', label: '원판' },
    { id: 'PROCESS', label: '가공' },
    { id: 'SUB_MATERIAL_PROCESS', label: '가공부자재' },
    { id: 'SUB_MATERIAL_BUILD', label: '시공부자재' }
  ];
};

// Division이 유효한지 확인하는 함수
export const isValidDivision = (divisionId) => {
  const validDivisions = ['RAW_MATERIAL', 'PROCESS', 'SUB_MATERIAL_PROCESS', 'SUB_MATERIAL_BUILD'];
  return validDivisions.includes(divisionId);
}; 